import React from 'react';
import { Dialog, DialogContent, Alert, Typography, Button } from '@mui/material';

interface ErrorModalProps {
  open: boolean;
  onClose: () => void;
  errorMessage: string | null;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ open, onClose, errorMessage }) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          borderRadius: 5,
          padding: 20,
          minWidth: '400px'
        }
      }}
    >
      <DialogContent>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', marginBottom: '10px' }}>
          <img src="/assets/icons/WarningCircle.svg" alt="WarningIcon" width={147} height={147} />
        </div>
        <Typography
          style={{
            color: '#1A1A1A',
            fontSize: 28,
            fontFamily: 'Helvetica Neue LT Std',
            fontWeight: 300,
            wordWrap: 'break-word',
            textAlign: 'center',
            marginBottom: '20px'
          }}
        >
          Operation Failed
        </Typography>
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <Button variant="contained" onClick={onClose}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorModal;